import { type InfiniteData } from "@tanstack/react-query";

import { type ApiResponseNotificationList } from "@vega-api/generated/types/apiResponseNotificationList";
import { type NotificationResponse } from "@vega-api/generated/types/notificationResponse";

export type NotificationsListInfinite =
  InfiniteData<ApiResponseNotificationList>;

export const updateAllPages = (
  current: NotificationsListInfinite | undefined,
  mapEntries: (data: NotificationResponse[]) => NotificationResponse[],
): NotificationsListInfinite | undefined => {
  if (!current) return current;

  return {
    ...current,
    pages: current.pages.map((page) => ({
      ...page,
      data: mapEntries(page.data),
    })),
  };
};
